export default {
  getSelectedProduct: (state) => {
    return state.selectedProduct;
  },
  getPreSelectedProduct: (state) => {
    return state.preSelectedProduct;
  },
  getCurrentCart: (state) => {
    return state.carts.find((x) => x && x.active);
  },
  getSid: (state, getters) => {
    const cart = getters.getCurrentCart;
    if (!cart) return null;
    // v152: DB güncellemesi için UUID (branchTableUId) kritik öneme sahiptir. 
    // Hem camelCase hem PascalCase kontrolü ekleyerek hata payını sıfırlıyoruz.
    return cart.branchTableUId || cart.BranchTableUId || cart.sid || cart.id;
  },
  getCurrentTab: (state) => {

    return state.currentTab;
  },
  getCarts: (state) => {
    return state.carts;
  },
  getScreenLock: (state) => {
    return state.screenLock;
  },
  getIsLoading: (state) => {
    return state.isLoading;
  },
  getActivePersonal: (state) => {
    return state.activePersonal;
  },
  getPersonList: (state) => {
    return state.personList;
  },
  getToUpdateEntry: (state) => {
    // eslint-disable-next-line no-undef
    if (state.toUpdateEntry != null) return _.cloneDeep(state.toUpdateEntry);
    else return null;
  },
  getToIsReset: (state) => {
    return state.isReset;
  },
  getToLastBillId: (state) => {
    return state.lastBillId;
  },
  getPaymentMethods: (state) => {
    return state.paymentMethods;
  },
  getSelectedPaymentMethod: (state) => {
    return state.selectedPaymentMethod;
  },
  getLossMode: (state) => {
    return state.isLossModeOn;
  },
  getLossType: (state) => {
    return state.lossTypeSelection;
  },
  getSelectedLossStocks: (state) => {
    return state.selectedLossStocks;
  },
  getCakeQuestioned: (state) => {
    return state.isCakeQuestioned;
  },
  getNavigationQuestion: (state) => {
    return state.navigationQuestion;
  },
  hasNeedNavigationByQuestion: (state) => {
    return state.hasNeedNavigationByQuestion;
  },
  getAreas: (state) => {
    return state.areas;
  },
  getIsTableMove: (state) => {
    return state.isTableMove;
  },
  getIsTableMerge: (state) => {
    return state.isTableMerge;
  },
  getPrinterSettings: (state) => {
    return state.printerSettings;
  },
  getSelectedPosId: (state) => {
    return state.selectedPosId;
  },
  getKuverSettings: (state) => {
    return state.kuverSettings;
  },
  getDiscountReasons: (state) => {
    return state.discountReasons;
  },
  getIsActiveTablesFilter: (state) => {
    return state.isActiveTablesFilter;
  }
};
